import React from 'react';
import ReactDOM from 'react-dom/client';
import 'driver.js/dist/driver.css';
import './index.css';
import './styles/typography.css';
import App from './App';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './utils/queryClient';
import { initSafariPolyfills } from './utils/safariPolyfills';
import { logger } from './utils/logger';
import { initializeApm } from './utils/apm';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
// import reportWebVitals from './reportWebVitals';

// Initialize APM RUM as early as possible
initializeApm();

// Initialize Safari polyfills
try {
  initSafariPolyfills();
} catch (error) {
  logger.warn('Failed to initialize Safari polyfills', 'Bootstrap', error);
  // Continue with app initialization even if polyfills fail
}

// Theme is now managed by ThemeContext

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);

serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(logger.info))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
